import * as styles from './ChecklistCard.css';
import { Typography } from '@design-system/components/typography/typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faCheck } from '@fortawesome/pro-light-svg-icons';
import { navigate } from '@client/routes';
import clsx from 'clsx';
import { mixTrack } from '@services/mixpanel';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

type ChecklistCardType = {
  onClick?: () => void;
  icon: IconProp;
  isCompleted: boolean;
  title: string;
  link?: string;
};

export const ChecklistCard = (props: ChecklistCardType) => {
  const onClick = () => {
    if (props.isCompleted) return;
    mixTrack({
      type: 'Checklist Card Tapped' as any,
      payload: { title: props.title },
    });
    if (props.onClick) props.onClick();
    if (props.link) navigate(props.link);
  };
  return (
    <div
      className={clsx(styles.card, props.isCompleted && styles.completed)}
      onClick={onClick}
    >
      <FontAwesomeIcon icon={props.icon} />
      <Typography variant="bodyLarge" fontWeight="medium">
        {props.title}
      </Typography>

      <FontAwesomeIcon
        icon={props.isCompleted ? faCheck : faChevronRight}
        className={styles.icon}
      />
    </div>
  );
};
